import { createApp } from 'vue'
import App from './App.vue'
import router from './routes/routes'
import store from './store/index'
import { createHead } from '@vueuse/head'
import "./index.css"
// import SeoPlugin from './plugins/seo';

import axios from './axios'
import VueAxios from 'vue-axios'
const head = createHead()
router.beforeEach((to, from, next) => {
  // Scroll vers le haut à chaque changement de page
  window.scrollTo(0, 0);
  
  // Métadonnées par défaut si aucune n'est définie
  if (!to.meta.metaInfo) {
    document.title = 'Cassus E-commerce - Votre boutique en ligne au Cameroun';
  }
  
  next();
});

createApp(App).use(store).use(head).use(router).use(VueAxios, axios).mount('#app')
